// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3Iil6","insightsList":"newBusinessInsightsMenu_insightsList__26pQx","active":"newBusinessInsightsMenu_active__2BcoP"};